// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"541":"c6b5fadc","551":"ab8edd91","605":"c6b5fadc"}[chunkId] + ".chunk.css";
};